import {
  ResignationStateTypes,
  ResignationActionTypes,
} from "./Resignation.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ResignationStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ResignationReducer = (
  state: ResignationStateTypes = INITIAL_STATE,
  action: any
): ResignationStateTypes => {
  switch (action.type) {
    case ResignationActionTypes.FETCH_ALL_RESIGNATION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ResignationActionTypes.FETCH_ALL_RESIGNATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ResignationActionTypes.FETCH_ALL_RESIGNATION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ResignationActionTypes.FETCH_ALL_RESIGNATION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ResignationActionTypes.FETCH_ONE_RESIGNATION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ResignationActionTypes.FETCH_ONE_RESIGNATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ResignationActionTypes.FETCH_ONE_RESIGNATION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ResignationActionTypes.FETCH_ONE_RESIGNATION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ResignationReducer;
